<div class="modal-header">
    <h4 class="modal-title">Detalle Compra</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="compra">
        <div class="row">
            <div class="col-6 col-md">
                <label for="fecha">Fecha</label>
                <input type="text" class="form-control" formControlName="fecha">
            </div>
            <div class="col-6 col-md">
                <label for="monto">Monto</label>
                <input type="text" class="form-control" formControlName="monto">
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md">
                <label for="detalle">Detalle</label>
                <textarea class="form-control" formControlName="detalles" cols="10" rows="5"></textarea>
            </div>
        </div>
    </form>
    <hr>
    <h4>Total: {{formatter.numberFormat(total)}}</h4>
    <table class="table table-bordered">
        <thead>
            <tr>
                <td>Productos</td>
                <td>Cant</td>
                <td>Precio unitario</td>
                <td>Precio linea</td>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let linea of element.lineas">
                <td>{{linea.productos.nombre}} </td>
                <td>{{formatter.numberFormat(linea.cantidad)}} </td>
                <td>{{formatter.numberFormat(linea.precio_unitario)}} </td>
                <td>{{formatter.numberFormat(linea.precio_linea)}} </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancelar</button>
</div>
